import { useState, useEffect, useCallback } from 'react'
import { API_URL } from 'store/fetchUtils'

const cache = new Map()

export const useJustifications = (categoryId) => {
	const [justifications, setJustifications] = useState([])
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState(null)

	const fetchJustifications = useCallback(async () => {
		if (!categoryId) return

		if (cache.has(categoryId)) {
			setJustifications(cache.get(categoryId))
			return
		}

		setIsLoading(true)
		setError(null)

		try {
			const response = await fetch(
				`${API_URL}/api/suggest/justifications/category/${categoryId}`,
				{
					method: 'GET',
					headers: {
						'Content-Type': 'application/json',
					},
				}
			)

			if (!response.ok) {
				throw new Error('Failed to fetch justifications')
			}

			const data = await response.json()
			const rawItems = data.items || []
			const justificationList = rawItems.map((item) => ({
				justificationId: item.id,
				justificationName: item.justificationName,
				categoryId: item.categoryId,
				categoryName: item.categoryName,
			}))

			cache.set(categoryId, justificationList)
			setJustifications(justificationList)
		} catch (err) {
			setError(err.message)
			setJustifications([])
		} finally {
			setIsLoading(false)
		}
	}, [categoryId])

	useEffect(() => {
		fetchJustifications()
	}, [fetchJustifications])

	const refresh = useCallback(() => {
		if (categoryId) {
			cache.delete(categoryId)
			fetchJustifications()
		}
	}, [categoryId, fetchJustifications])

	return {
		justifications,
		isLoading,
		error,
		refresh,
	}
}

export const clearJustificationsCache = () => {
	cache.clear()
}
